import React from "react"
import SbEditable from "storyblok-react"
import { blokType } from "../../types"

import { SectionCmp, SectionProps } from "./Section"

interface SectionWrapperBlokProps {
  blok: SectionProps & blokType
}

const S23CSection: React.FC<SectionWrapperBlokProps> = ({ blok }) => (
  <SbEditable content={blok}>
    <SectionCmp
      id={blok._uid}
      icon={blok.icon}
      title={blok.title}
      description={blok.description}
      body={blok.body}
      background_color={blok.background_color}
      custom_id={blok.custom_id}
      microdata={blok.microdata}
    />
  </SbEditable>
)

export default S23CSection
